import React from 'react';
import { useAgentConversations } from '../../../contexts/AgentConversationsContext';
import ConversationList from './ConversationList';
import ConversationThread, { ThreadExtras } from './ConversationThread';
import PatientContextChip from '../../agent-context/PatientContextChip';

// The inside of the agent panel when the backend has conversations: the list,
// or one conversation (or a new one, before its first message).
const ConversationsPanelBody: React.FC<{ onClose: () => void } & ThreadExtras> = ({ onClose, ...extras }) => {
  const agent = useAgentConversations()!;
  if (agent.view === 'thread' && agent.active) {
    return (
      <ConversationThread
        onClose={onClose}
        renderPatientContext={(patient) => <PatientContextChip patient={patient} />}
        {...extras}
      />
    );
  }
  return <ConversationList onClose={onClose} />;
};

export default ConversationsPanelBody;
